module.exports = {
    HostsV3Up: { // Router com a mensageria com websockets
        "host": "https://apontamento.grv.net.br:9081",
        "host_alt1": "http://ws1.grv.net.br:9081",
        "host_alt2": "http://ws2.grv.net.br:9081",
    }
}

